// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import InputIcon from "@mui/icons-material/Input";
import {changeExpense} from "../../WorkIssuanceExpense/expenseSlice";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function IssueExpense({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const handleIssue = () => {

        dispatchData(changeWorkIssuance({newStatus:  '3242', updateCdpStatus: true}));

        onMenuClose();
    };


    return (

        <Box>
            {(
                    ((rowCdpStatus === "2354" || rowCdpStatus === "4553") && showExpense === true)
                ) &&
                <MenuItem onClick={handleIssue}>
                    <ListItemIcon>
                        <InputIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Issue</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
